<template>
  <div>
    <common-dialog
      ref="dialog"
      width="1200px"
      :title="data.IsDetail ? '查看' : '编辑'"
      id-key="UserId"
      :data="data"
      @edit-opened="opened"
      @close-saved="$emit('close-saved')"
      @close="closed"
      :confirm-on-close-change="false"
    >
      <!-- <template slot="form"> -->
      <div class="box-header" v-if="!data.IsDetail"><el-button type="success" @click="addGoods">添加</el-button> <el-button type="danger" @click="delGoods">删除</el-button></div>
      <el-table :data="tableData" border @selection-change="onSelectGoods">
        <el-table-column type="selection" width="35" v-if="!data.IsDetail" />
        <el-table-column prop="ScheduledId" label="班次" v-if="data.ProductionType != 1">
          <template slot-scope="{ row }">
            <el-select v-model="row.ScheduledId" @change="changeSchedule(row, $event)" :disabled="data.IsDetail">
              <el-option v-for="item in scheduleList" :key="item.ScheduleId" :value="item.ScheduleId" :label="item.Schedule"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="TeamId" label="班组" v-if="data.ProductionType != 1">
          <template slot-scope="{ row }">
            <el-select v-model="row.TeamId" @change="changeTeam(row, $event)" :disabled="data.IsDetail">
              <el-option v-for="item in teamList" :key="item.TeamId" :value="item.TeamId" :label="item.Team"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="MaintenanceId" label="加工设备" v-if="data.ProductionType != 1">
          <template slot-scope="{ row }">
            <el-select v-model="row.MaintenanceId" @change="changeEquipment(row, $event)" :disabled="data.IsDetail" clearable>
              <el-option v-for="item in equipmentList" :key="item.EquipmentId" :label="item.EquipmentName" :value="item.EquipmentId"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="ThisPlanQuantity" label="排产数量">
          <template slot-scope="{ row }">
            <el-input v-model="row.ThisPlanQuantity" type="text" :disabled="data.IsDetail"></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="StartDate" label="开始时间" min-width="130px">
          <template slot-scope="{ row }">
            <el-date-picker
              v-model="row.StartTime"
              type="datetime"
              placeholder="选择日期时间"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              :disabled="data.IsDetail"
              :picker-options="pickerOptions"
              @change="changeStartDate(row, $event)"
            >
            </el-date-picker>
          </template>
        </el-table-column>
        <el-table-column prop="EndDate" label="完成时间" min-width="130px">
          <template slot-scope="{ row }">
            <el-date-picker v-model="row.EndTime" type="datetime" :disabled="data.IsDetail" placeholder="选择日期时间" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss">
            </el-date-picker>
          </template>
        </el-table-column>
      </el-table>
      <!-- <el-row class="border">
          <el-row :gutter="15">
            <el-col :span="6">
              <el-form-item label="班次">
                <el-select v-model="data.ScheduleId" @change="changeSchedule">
                  <el-option v-for="item in scheduleList" :key="item.ScheduleId" :value="item.ScheduleId" :label="item.Schedule"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="选择班组">
                <el-select v-model="data.TeamId">
                  <el-option v-for="item in teamList" :key="item.TeamId" :value="item.TeamId" :label="item.Team"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="加工设备">
                <el-select v-model="data.MaintenanceId">
                  <el-option v-for="item in equipmentList" :key="item.EquipmentId" :label="item.EquipmentName" :value="item.EquipmentId"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

        
        </el-row> -->
      <!-- </template> -->

      <template slot="footer">
        <el-button type="primary" @click="print">打 印</el-button>
        <el-button type="primary" @click="save" v-if="!data.IsDetail">保存</el-button>
        <el-button @click="closeDialog">关 闭</el-button>
      </template>
    </common-dialog>
  </div>
</template>
  
  <script>
import editDialogMixin from '@/mixins/editDialog'
import commonDialog from '@/components/common/dialog'

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog
  },
  props: {
    wid: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      api: require('@/api/ba/team').default,
      planApi: require('@/api/pu/plan').default,
      equipmentApi: require('@/api/ba/equipment').default,
      scheduleApi: require('@/api/ba/schedule').default,
      data: {
        WorkDocIds: [],
        TeamId: null,
        Team: '',
        ScheduleId: null,
        Schedule: '',
        MaintenanceId: null,
        Wages: null,
        Quantity: 0
      },
      printData: {
        OrderNo: '', // 订单号
        WorkDocNo: '', // 工单号
        BatchNumber: '', // 批次号
        ProductNo: '', // 产品编码
        ProductName: '', // 产品名称
        ProductSpec: '', // 产品规格
        BarCode: "",
        PlanDts: []
      },
      teamList: [],
      copyTeamList: [],
      scheduleList: [],
      equipmentList: [],
      tableData: [
        {
          ThisPlanQuantity: 0
        }
      ],
      selectDetails: [],
      timeList: [],
      schedulingDates: [],
      pickerOptions: {
        disabledDate: time => {
          let bool = false

          let year = time.getFullYear()
          let month = time.getMonth() + 1
          let day = time.getDate()

          //console.log('selectableRange', this.pickerOptions.selectableRange,this.schedulingDates)

          let t = `${year}/${month}/${day}`
          let index = this.schedulingDates.indexOf(t)
          if (index === -1) {
            bool = true
          }
          //console.log(t,index,"t");

          return bool
        }
      }
    }
  },
  created() {
    this.planApi.schedulingDateRange({ SchedulingType: 0 }).then(res => {
      if (res.Code === 0) {
        this.timeList = res.Data
        this.schedulingDates = this.timeList.map(item => {
          return item.SchedulingDate
        })
        if (this.timeList.length > 0) {
          console.log(this.timeList, 'this.timeList ')
          this.pickerOptions.selectableRange = `${this.timeList[0].SchedulingTimeRanges[0].SchedulingStartTime}:00 - ${this.timeList[0].SchedulingTimeRanges[0].SchedulingEndtTime}:00`
        }
      }
    })
    this.api.list({DpId:this.data.DpId}).then(res => {
      if (res.Code === 0) {
        this.copyTeamList = JSON.parse(JSON.stringify(res.Data))
        this.teamList = JSON.parse(JSON.stringify(res.Data))

        // let ScheduleIds = []
        // let arr = []
        // res.Data.forEach(item => {
        //   let index = ScheduleIds.indexOf(item.Schedule)
        //   if (index === -1) {
        //     arr.push({
        //       Schedule: item.Schedule,
        //       ScheduleId: item.ScheduleId
        //     })
        //   }
        //   ScheduleIds.push(item.Schedule)
        // })
        // this.scheduleList = arr

        // console.log('this.scheduleList', this.scheduleList)
      }
    })
    this.scheduleApi.list({}).then(res => {
      if (res.Code == 0) {
        this.scheduleList = JSON.parse(JSON.stringify(res.Data))
      }
    })
  },
  methods: {
    changeStartDate(row, val) {
      console.log(val, row, 'changeStartDate')
      if (row.MaintenanceId > 0) {
        this.getCapacity(row.MaintenanceId, row)
      }
    },
    changeEquipment(row, val) {
      console.log(val, row, 'changeEquipment')
      var equipment = this.equipmentList.find(x => x.EquipmentId == val)
      if (equipment) {
        row.MaintenanceName = equipment.EquipmentName
      }
      if (val) {
        this.getCapacity(val, row)
      }
    },
    getCapacity(val, row) {
      this.equipmentApi.checkCapacity({ EquipmentId: val }).then(res => {
        if (res.Code === 0) {
          var obj = res.Data
          console.log(obj, row, 'obj')
          var hours = 0
          if (row.ThisPlanQuantity) {
            if (!obj.info.Cycle) {
              this.$message.warning('该设备未设置成品周期')
              return false
            }

            hours = Math.ceil(row.ThisPlanQuantity / obj.info.CycleOutPut)
            console.log(hours, obj.info.CycleOutPut, 'hours3')
          }
          console.log(hours, 'hours')
          if (row.StartTime) {
            var endtime = new Date(row.StartTime)
            var newEndTime = new Date(endtime.getTime() + hours * 60 * 60 * 1000)
            if (row.EndTime) {
              var et = new Date()
              if (newEndTime.getTime() > et.getTime()) {
                this.$confirm('完工时间比预设完工时间久, 是否替换预设完工时间?', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                })
                  .then(() => {
                    row.EndTime = this.$commonJs.toDatetimeString(newEndTime)
                  })
                  .catch(() => {})
              } else {
                row.EndTime = this.$commonJs.toDatetimeString(newEndTime)
              }
            } else {
              row.EndTime = this.$commonJs.toDatetimeString(newEndTime)
            }
          }
        }
      })
    },
    onSelectGoods(selection) {
      console.log(selection, 'selection-change')
      this.selectDetails = selection
    },
    addGoods() {
      if (this.tableData.length > 0) {
        console.log(this.tableData, '')
        var sum = 0
        this.tableData.forEach(item => {
          sum += Number(item.ThisPlanQuantity)
        })
        console.log(sum, 'sum')
        if (sum < this.data.Quantity) {
          this.tableData.push({
            ThisPlanQuantity: this.data.Quantity - sum,
            EndTime: null,
            StartTime: this.data.StartTime,
            MaintenanceId: null,
            MaintenanceName: '',
            TeamId: null,
            Team: '',
            Schedule: '',
            ScheduledId: null
          })
        } else {
          this.tableData.push({
            ThisPlanQuantity: 0,
            EndTime: null,
            StartTime: this.data.StartTime,
            MaintenanceId: null,
            MaintenanceName: '',
            TeamId: null,
            Team: '',
            Schedule: '',
            ScheduledId: null
          })
        }
      } else {
        this.tableData.push({
          ThisPlanQuantity: this.data.Quantity,
          EndTime: null,
          StartTime: this.data.StartTime,
          MaintenanceId: null,
          MaintenanceName: '',
          TeamId: null,
          Team: '',
          Schedule: '',
          ScheduledId: null
        })
      }
      this.tableData.forEach((x, i) => {
        x.Index = i
      })
    },
    delGoods() {
      if (this.selectDetails.length == 0) {
        this.$message.warning('请选择要删除的数据')
        return
      }
      this.selectDetails.forEach(x => {
        var index = this.tableData.findIndex(w => w == x)
        this.tableData.splice(index, 1)
      })
      //清空选中的数据
      this.selectDetails = []
      //对序号进行重新排序
      this.tableData.forEach((x, i) => (x.Index = i))
    },
    getequipmentList(EquipmentTypeId) {
      this.equipmentApi.list({ Statuses: [1, 2], EquipmentTypeId }).then(res => {
        if (res.Code === 0) {
          this.equipmentList = res.Data
        }
      })
    },
    save() {
      if (this.data.ProductionType == 0) {
        for (let index = 0; index < this.tableData.length; index++) {
          const item = this.tableData[index]
          if (item.ScheduledId == null || item.TeamId == null) {
            this.$message({ type: 'warning', message: '请选择班组和班次' })
            return
          }
          // if (this.data.Stage == 0) {
          //   if (item.MaintenanceId == null || item.MaintenanceId == 0) {
          //     this.$message({ type: 'warning', message: '请选择设备' })
          //     return
          //   }
          // }

          if (item.ThisPlanQuantity == null || item.ThisPlanQuantity == 0) {
            this.$message({ type: 'warning', message: '请填写排产数量' })
            return
          }
        }
      } else {
        for (let index = 0; index < this.tableData.length; index++) {
          const item = this.tableData[index]

          if (item.ThisPlanQuantity == null || item.ThisPlanQuantity == 0) {
            this.$message({ type: 'warning', message: '请填写排产数量' })
            return
          }
        }
      }

      var tableData = JSON.parse(JSON.stringify(this.tableData))
      var data = JSON.parse(JSON.stringify(this.data))
      data.PlanDts = tableData.filter(x => Number(x.ThisPlanQuantity) > 0)
      var maintenances = data.PlanDts.map(x => x.MaintenanceName)
      var schedules = data.PlanDts.map(x => x.Schedule)
      var teams = data.PlanDts.map(x => x.Team)
      if (maintenances) {
        data.Maintenance = maintenances.join(',')
      }
      data.Schedule = schedules.join(',')
      data.Team = teams.join(',')
      this.$emit('change', data)
      this.close()

      // var loading = this.$loading({
      //   lock: true,
      //   text: '正在保存...',
      //   spinner: 'el-icon-loading',
      //   customClass: 'my_loading',
      //   background: 'rgba(0, 0, 0, 0.3)'
      // })

      // this.planApi
      //   .changeTeam(this.data)
      //   .then(res => {
      //     if (res.Code === 0) {
      //       this.$message({ type: 'success', message: res.Msg })
      //       this.$emit('change', this.data)
      //       loading.close()
      //       this.close()
      //     } else {
      //       this.$message({ type: 'warning', message: res.Msg })
      //       loading.close()
      //     }
      //   })
      //   .catch(err => {
      //     console.error(err)
      //     loading.close()
      //   })
    },
    print() {
      sessionStorage.setItem('teamscheduling_print', JSON.stringify(this.printData))
      var origin = location.origin
      window.open(origin + '/#/production/scheduling/teamscheduling/print')
    },
    closeDialog() {
      this.close()
    },
    opened(row) {
      console.log('row', row)
      this.data.ProductionType = row.ProductionType
      this.data.WorkDocIds = row.WorkDocIds
      this.data.TeamId = row.TeamId
      this.data.Team = row.Team
      this.data.ScheduledId = row.ScheduleId
      this.data.Schedule = row.Schedule
      this.data.MaintenanceId = row.MaintenanceId
      this.data.Maintenance = row.MaintenanceName
      this.data.Wages = row.Wages
      this.tableData = row.PlanDts || []
      this.data.Quantity = row.Quantity
      this.data.index = row.index
      this.data.IsDetail = row.IsDetail || false
      this.data.Stage = row.Stage
      this.data.StartTime = row.StartTime
      this.data.DpId=row.DpId

      this.printData.OrderNo = row.OrderNo
      this.printData.WorkDocNo = row.WorkDocNo
      this.printData.BatchNumber = row.BatchNumber
      this.printData.ProductNo = row.ProductNo
      this.printData.ProductName = row.ProductName
      this.printData.BarCode = row.BarCode
      this.printData.PlanDts = row.PlanDts

      // let TeamList = this.copyTeamList.filter(item => {
      //   return this.data.Schedule === item.Schedule
      // })

      if (this.tableData.length == 0) {
        this.tableData.push({
          ThisPlanQuantity: this.data.Quantity,
          EndTime: null,
          StartTime: this.data.StartTime,
          MaintenanceId: null,
          MaintenanceName: '',
          TeamId: null,
          Team: '',
          Schedule: '',
          ScheduledId: null
        })
      }

      this.tableData.forEach((x, i) => {
        x.Index = i
        if (x.ScheduledId) {
          let TeamList = this.copyTeamList.filter(item => {
            return x.ScheduledId === item.ScheduleId
          })
          console.log('TeamList', TeamList)
          x.teamList = TeamList
        }
      })
      console.log(this.tableData, 'this.tabledata')
      //this.TeamList = TeamList
      if (this.data.Stage == 0) {
        this.getequipmentList(6)
      } else {
        this.getequipmentList()
      }
    },
    changeSchedule(row, val) {
      this.data.TeamId = null
      this.data.Team = ''

      let item = this.scheduleList.filter(item => {
        return item.ScheduleId === val
      })[0]
      this.data.ScheduledId = item.ScheduleId
      this.data.Schedule = item.Schedule
      row.Schedule = item.Schedule

      // let TeamList = this.copyTeamList.filter(item => {
      //   return this.data.Schedule === item.Schedule
      // })
      // console.log('TeamList', TeamList)
      // row.teamList = TeamList
    },
    changeTeam(row, val) {
      this.data.TeamId = null
      this.data.Team = ''
      let item = this.teamList.filter(item => {
        return item.TeamId === val
      })[0]
      this.data.TeamId = item.TeamId
      this.data.Team = item.Team
      row.Team = item.Team
    },
    closed() {
      console.log('closed')
      var tableData = JSON.parse(JSON.stringify(this.tableData))
      var data = JSON.parse(JSON.stringify(this.data))
      data.PlanDts = tableData.filter(x => Number(x.ThisPlanQuantity) > 0)
      var maintenances = data.PlanDts.map(x => x.MaintenanceName)
      var schedules = data.PlanDts.map(x => x.Schedule)
      var teams = data.PlanDts.map(x => x.Team)
      data.Maintenance = maintenances.join(',')
      data.Schedule = schedules.join(',')
      data.Team = teams.join(',')
      this.$emit('change', data)
      this.close()
    }
  }
}
</script>
  